import { twClassMerge } from '@healthhub/react-ui';
import type { CheckboxProps } from 'antd';
import { Checkbox as AntdCheckbox } from 'antd';
import { memo } from 'react';


import styles from './styles.module.css';

// TODO: to revamp
const PortalCheckbox = ({ className, ...props }: CheckboxProps) => (
  <AntdCheckbox {...props} className={twClassMerge(styles.checkBox, className)} />
);

export default memo(PortalCheckbox);
